// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__SXrrZ","icon":"SortAdornment_icon__38Epy","up":"SortAdornment_up__2e6Tz","down":"SortAdornment_down__3HnLI","active":"SortAdornment_active__126uD"};